import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

if (typeof window !== `undefined`) {
  gsap.registerPlugin(ScrollTrigger);
  gsap.core.globals("ScrollTrigger", ScrollTrigger);
}

(() => {
  ScrollTrigger.defaults({
    // markers: true,
    start: "top 80%",
    duration: 0.75,
  });
  const icons = document.querySelectorAll(".c-block::before");
  const iconsArray = Array.prototype.slice.call(icons, 0);
  iconsArray.forEach((icon, i) => {
    gsap.from(icon, {
      opacity: 0,
      scale: 2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: icon,
      },
    });
  });
  const blockTitles = document.querySelectorAll(".c-block__title");
  const blockTitlesArray = Array.prototype.slice.call(blockTitles, 0);
  blockTitlesArray.forEach((title, i) => {
    gsap.from(title, {
      opacity: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: title,
      },
    });
  });
  const textDescs = document.querySelectorAll(".c-text-desc");
  const textDescsArray = Array.prototype.slice.call(textDescs, 0);
  textDescsArray.forEach((textDesc, i) => {
    gsap.from(textDesc, {
      opacity: 0,
      y: 50,
      ease: "power2.out",
      scrollTrigger: {
        trigger: textDesc,
      },
    });
  });
  gsap.from(".c-product-card", {
    opacity: 0,
    y: 50,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".c-product-cardcontainer",
    },
    stagger: {
      from: "start",
      amount: 0.25,
    },
  });
  const compeHeads = document.querySelectorAll(".c-compe__head");
  const compeHeadsArray = Array.prototype.slice.call(compeHeads, 0);
  compeHeadsArray.forEach((compeHead, i) => {
    gsap.from(compeHead, {
      opacity: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: compeHead,
      },
    });
  });
  const compeContents = document.querySelectorAll(".c-compe__contents");
  const compeContentsArray = Array.prototype.slice.call(compeContents, 0);
  compeContentsArray.forEach((contents, i) => {
    gsap.from(contents, {
      opacity: 0,
      y: 50,
      ease: "power2.out",
      scrollTrigger: {
        trigger: contents,
      },
    });
  });
  gsap.from(".c-recipe-list__item", {
    opacity: 0,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".c-recipe-list",
    },
    stagger: {
      from: "start",
      amount: 0.25,
    },
  });

  gsap.from(".c-comment-container__col", {
    opacity: 0,
    y: 50,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".c-comment-container",
    },
    stagger: {
      from: "start",
      amount: 0.25,
    },
  });
})();
